import {Component, OnInit} from '@angular/core';
import {CheckCardBalanceResponse} from '../../model/CheckCardBalanceResponse';
import {CheckCardHistoryResponse} from '../../model/CheckCardHistoryResponse';
import {RestConnectionService} from '../../service/rest-connection.service';
import {InputAuthBody} from '../../model/inputAuthBody';

@Component({
  selector: 'app-card-input',
  templateUrl: './card-input.component.html',
  styleUrls: ['./card-input.component.css']
})
export class CardInputComponent implements OnInit {

  public displayData = false;
  public mediumScreen = false;
  public pinNeeded = false;
  public displayWarning = false;
  public cardNumber = '';
  public cardPin = '';
  public loading = false;
  public warningMessage = 'Podaj pin';

  constructor(private restConnectionService: RestConnectionService) {
  }

  cardBalanceBody: CheckCardBalanceResponse;
  cardHistoryBody: CheckCardHistoryResponse;

  private static createAuthId(): string {
    let authIdNumber = '';
    do {
      authIdNumber += Math.floor(Math.random() * Math.floor(9));
    } while (authIdNumber.length < 16);
    return authIdNumber;
  }

  ngOnInit(): void {
    this.mediumScreen = window.innerWidth < 570;
    window.onresize = () => this.mediumScreen = window.innerWidth < 570;
  }

  public checkPinValidation(): boolean {
    if (this.pinNeeded === true) {
      return this.cardPin.length !== 4 || this.cardNumber.length !== 13;
    } else {
      return this.cardNumber.length !== 13;
    }
  }

  public checkCard(): void {
    this.loading = true;

    const checkCardBalanceBody: InputAuthBody = {
      AuthId: CardInputComponent.createAuthId(),
      PinNumber: this.cardPin,
      SerialNumber: this.cardNumber
    };

    this.restConnectionService.checkCardBalance(checkCardBalanceBody).then(res => {
      this.displayWarning = true;


      this.cardBalanceBody = res;
      if (this.cardBalanceBody.ErrorCode.toString() === '-51') {
        if (this.pinNeeded) {
          this.loading = false;
          this.displayWarning = true;
        }
        if (this.pinNeeded) {
          this.loading = false;
          this.warningMessage = 'Wpisano niepoprawny numer karty lub pin';
        }
        this.pinNeeded = true;
      } else {
        this.restConnectionService.checkCardHistory(checkCardBalanceBody).then(historyBodyResponse => {
          this.cardHistoryBody = historyBodyResponse;
          this.displayData = true;
          this.loading = false;
        }, error => {
          console.error('error', error);
        });
      }
    }, e => {
      this.loading = false;
      console.error(e);
    });
  }

  public hideData(event): void {
    this.displayData = event;
  }
}
